<template>
  <div>TMZ</div>
</template>

<script>
export default {
  name: "CheckTmzStep",
  methods: {
    checkStep(){
      this.$store.dispatch('checkTmzStep');
    }
  },
  mounted() {
    this.checkStep();
  }
}
</script>

<style scoped>

</style>